var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOption,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "search-change": _vm.searchChange,
              "refresh-change": _vm.refreshChange,
              "row-del": _vm.rowDel,
            },
            scopedSlots: _vm._u([
              {
                key: "menuBtn",
                fn: function (scope) {
                  return [
                    _vm.permissions.act_process_manage
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handlePic(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("流程图\n        ")]
                        )
                      : _vm._e(),
                    _vm.permissions.act_process_manage && scope.row.suspend
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleStatus(scope.row, "active")
                              },
                            },
                          },
                          [_vm._v("激活\n        ")]
                        )
                      : _vm._e(),
                    _vm.permissions.act_process_manage && !scope.row.suspend
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleStatus(scope.row, "suspend")
                              },
                            },
                          },
                          [_vm._v("失效\n        ")]
                        )
                      : _vm._e(),
                    _vm.permissions.act_process_manage
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleDel(scope.row, "suspend")
                              },
                            },
                          },
                          [_vm._v("删除\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showPicDialog, title: "流程图" },
          on: {
            "update:visible": function ($event) {
              _vm.showPicDialog = $event
            },
          },
        },
        [_c("img", { attrs: { src: _vm.actPicUrl, width: "100%" } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }